import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { TransformCta } from '../TransformCta';
const FAQS = [{
  question: '¿Cómo recibiré el sistema?',
  answer: 'Inmediatamente después de completar tu compra recibirás acceso para descargar los 6 tomos y los 5 bonos en formato PDF. Podrás consultarlos desde tu computadora, tablet o teléfono, o imprimirlos para utilizarlos durante tu práctica clínica.'
}, {
  question: '¿Es útil si ya tengo experiencia en ortodoncia?',
  answer: 'Sí. El sistema no busca reemplazar tus conocimientos, sino ayudarte a organizarlos mediante un proceso clínico estructurado para que tomes decisiones con mayor seguridad y consistencia.'
}, {
  question: '¿Sirve para cualquier país?',
  answer: 'Sí. Todo el contenido está desarrollado en español neutro y puede aplicarse en cualquier consulta de ortodoncia de habla hispana. Además, el cambio de moneda es automático al momento de pagar.'
}, {
  question: '¿Es un pago único?',
  answer: 'Sí. Pagas una sola vez y el acceso es tuyo para siempre.'
}, {
  question: '¿Este sistema reemplaza mi criterio profesional?',
  answer: 'No. Es una herramienta educativa y de apoyo clínico que te ayuda a sistematizar tu proceso diagnóstico. La decisión final siempre corresponde al profesional tratante.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-4 py-14 sm:py-20" data-id="element-143" data-mp="32gltk6sp2ts2">
      <div className="mx-auto max-w-2xl" data-id="element-144" data-mp="3hemiuhz2i7d8">
        <h2 className="text-center font-display text-[26px] font-bold leading-[1.15] tracking-tight text-navy-900 sm:text-4xl" data-id="element-145" data-mp="3hdl8kfpvlowk">
          Preguntas frecuentes
        </h2>

        <ul className="mt-8 space-y-3" data-id="element-146" data-mp="1n0damf6lsx6p">
          {FAQS.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.question} className="overflow-hidden rounded-2xl border border-navy-100 bg-cream" data-id="element-147" data-mp="1i3mqngrohhg0" data-mpi={index}>
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left" data-id="element-148" data-mp="2bqrb3yvjsul8">
                  <span className="text-[14.5px] font-bold leading-snug text-navy-900 sm:text-base" data-id="element-149" data-mp="2qp1rk0ypcldo">
                    {faq.question}
                  </span>
                  <motion.span animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.2
              }} className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white text-gold-600" data-id="element-150" data-mp="2uokf74hwrak7">
                    <ChevronDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-151" data-mp="39gks81597ncj" />
                  </motion.span>
                </button>
                <AnimatePresence initial={false} data-id="element-152" data-mp="3ec062t39hj8y">
                  {isOpen ? <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-153" data-mp="12sc6ev7lghnu">
                      <p className="px-4 pb-4 text-[14px] leading-relaxed text-navy-600 sm:text-[15px]" data-id="element-154" data-mp="nvl5ghi9uxw4">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <TransformCta headline="Ya tienes las respuestas. Ahora dale a tu diagnóstico un método." label="Quiero empezar ahora" location="faq" data-id="element-155" data-mp="1bpcq4ojpxrky" />
      </div>
    </section>;
}